import Component from "../../component";
import {getDocHeight} from "../../helpers/viewport";
import {createCookie, readCookie} from "../../helpers/cookies";


export const EmailSignupConfig = {
    signature: 'EmailSignup',
    baseHtmlClass: 'email-signup',
    selector: '.email-signup',

    controlsSelector: '.email-signup__controls',
    checkboxSelector: '.email-signup__form_checkbox',
    formSelector: '.email-signup__form',
    embedSelector: '.email-signup__embed',
    removeSelector: '.email-signup__remove',

    consoleTag: '[Email Signup]',
    removeCookieName: 'STONE_ARROW__EMAIL_SIGNUP__REMOVE',

    embedStateEventType: 'klaviyoForms',
    embeddedFormTag: '__SUBSCRIBE_FORM_TAG__',
    embeddedSuccessTag: '__SUBSCRIBE_SUCCESS_TAG__'
};

export class EmailSignup extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: EmailSignupConfig
        });

        this.removed = this.getRemovedStoredState();
        if (this.removed) {
            infoMessage('Previously removed')
            this.selfDestruct();
            return;
        }

        this.controlsOpen = false;
        this.formOpen = false;

        this.hasEmbedSubmitted = false; // Has the user submitted the embedded form.
        this.hasEmbedSuccess = false; // Has the embedded form been submitted and the response was successful subscription.

        this.controlsElement = this.element.querySelector(EmailSignupConfig.controlsSelector); // Invites the user to reveal the signup form
        this.checkBoxElement = this.element.querySelector(EmailSignupConfig.checkboxSelector); // Controls the display of the signup form
        this.formElement = this.element.querySelector(EmailSignupConfig.formSelector); // The signup form
        this.embedElement = this.element.querySelector(EmailSignupConfig.embedSelector); // This element contains the embedded third party signup form.
        this.removeElements = this.element.querySelectorAll(EmailSignupConfig.removeSelector);

        // Listen for clicks on Remove elements.
        this.removeElements.forEach((element) => {
            element.addEventListener("click", this.remove.bind(this));
        });

        // Scroll listener to know when to show the controls as we scroll around.
        this.isOpeningControlsTicking = false;
        this.scrollListener = this.openingControlsScrollHandler.bind(this);
        window.addEventListener("scroll", this.scrollListener, false);

        // Listen for changes to the checkbox - controls if the signup for is showing.
        this.checkBoxElement.addEventListener('change', this.handleCheckboxChange.bind(this));

        // Listen for state change events from the third-party.
        window.addEventListener(EmailSignupConfig.embedStateEventType, this.handleEmbedStateChange.bind(this));

        this.render();

        // Delay setting `inited` and rendering again - this avoids flashing the controls in the viewport prior to setting other initial state.
        window.setTimeout(() => {
            this.inited = true;
            this.render();
        }, 1000);
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, 'inited');

        this.conditionallySetHtmlClassState(this.controlsOpen, 'controlsOpen');
        this.conditionallySetHtmlClassState(!this.controlsOpen, 'controlsClosed');

        this.conditionallySetHtmlClassState(this.formOpen, 'formOpen');
        this.conditionallySetHtmlClassState(!this.formOpen, 'formClosed');

        this.conditionallySetHtmlClassState(this.hasEmbedSuccess, 'hasEmbedSuccess');
    }

    // The checkbox element controls whether we are showing the form or not.
    // Clicks on the checkbox's labels change the `checked` state.
    handleCheckboxChange(event) {
        if (this.checkBoxElement.checked) {
            this.formOpen = true;
            this.controlsOpen = false;
        } else {
            this.formOpen = false;
            this.controlsOpen = true;
        }
        this.render();
    }


    // This scroll handler throttles the calls to `openingControlsHandler` which actually does the work.
    openingControlsScrollHandler() {
        if (!this.isOpeningControlsTicking) {
            window.requestAnimationFrame(() => {
                this.openingControlsHandler();
                this.isOpeningControlsTicking = false;
            });
            this.isOpeningControlsTicking = true;
        }
    };

    openingControlsHandler() {
        if (!this.formOpen) {
            this.controlsOpen = (window.pageYOffset >= showControlsOffset());
        }
        this.render();
    }


    handleEmbedStateChange(event) {
        const data = event.detail;
        const state = data?.type;
        if (state === 'submit') this.hasEmbedSubmitted = true;
        if (this.hasEmbedSubmitted) {
            // We assume that a submitted form is successful.
            this.hasEmbedSuccess = true;
            this.setRemovedStoredState(true);
        }
        this.render();
    }

    // We can test the state of the embedded third-party content by looking for the key phrase `EmailSignupConfig.embeddedSuccessTag` within its content.
    // This has been manually added to the embedded form's content within the third-party's form builder.
    // It's a bit of a brittle hack and is only necessary because the Klaviyo event doesn't report on the success/failure after a submit.
    // This is currently not being used - instead we are assuming that a submitted embed form is successful.
    isShowingEmbeddedSuccess() {
        return this.embedElement.innerText.indexOf(EmailSignupConfig.embeddedSuccessTag) !== -1
    }


    remove() {
        this.setRemovedStoredState(true);
        this.selfDestruct();
        infoMessage('Removed');
    };

    getRemovedStoredState() {
        return !!readCookie(EmailSignupConfig.removeCookieName);
    }

    setRemovedStoredState(value) {
        createCookie(EmailSignupConfig.removeCookieName, !!(value),365);
    }

    selfDestruct() {
        if (typeof this.scrollListener === 'function') {
            window.removeEventListener("scroll", this.scrollListener, false);
        }
        this.element.remove();
        infoMessage('Self destructed!');
    }

}


function showControlsOffset() {
    let pageHeight = getDocHeight();
    return (pageHeight - window.innerHeight) - (pageHeight / 2);
}

function infoMessage(message) {
    console.info(`${EmailSignupConfig.consoleTag} ${message}`);
}
